<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin-bottom:5px">
        <el-button size="mini" class="btn" type="primary" @click="onSave">保存</el-button>
      </el-row>
      <el-table ref="plxTable" :data="tableData" max-height="500" border highlight-current-row>
        <el-table-column align="center" label="年份" min-width="90" prop="year"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="Category2" min-width="100" prop="category2Name"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="供应商集团" min-width="140" prop="groupName"></el-table-column>
        <el-table-column align="center" label="供应商等级" min-width="140" prop="grade">
          <template v-slot="scope">
            <ic-select clearable table="TT_QSPI_QBR" field="GRADE" @change="gradeChange($event,scope.row)" v-model="scope.row.grade" style="width:100%"></ic-select>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="Min频率" min-width="100" prop="minFrequency"></el-table-column>
        <el-table-column align="center" label="Jan" min-width="100" prop="jan">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isJanCheck" :disabled="scope.row.isJan"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Feb" min-width="100" prop="feb">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isFebCheck" :disabled="scope.row.isFeb"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Mar" min-width="100" prop="mar">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isMarCheck" :disabled="scope.row.isMar"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Apr" min-width="100" prop="apr">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isAprCheck" :disabled="scope.row.isApr"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="May" min-width="100" prop="may">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isMayCheck" :disabled="scope.row.isMay"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Jun" min-width="100" prop="jun">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isJunCheck" :disabled="scope.row.isJun"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Jul" min-width="100" prop="jul">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isJulCheck" :disabled="scope.row.isJul"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Aug" min-width="100" prop="aug">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isAugCheck" :disabled="scope.row.isAug"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Sep" min-width="100" prop="sep">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isSepCheck" :disabled="scope.row.isSep"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Oct" min-width="100" prop="oct">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isOctCheck" :disabled="scope.row.isOct"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Nov" min-width="100" prop="nov">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isNovCheck" :disabled="scope.row.isNov"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Dec" min-width="100" prop="dec">
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.isDecCheck" :disabled="scope.row.isDec"></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import QBRApi from "@/api/QBR/index";
export default {
  name: 'qbrPlanDetail',
  components: {
    IcSelect,
  },
  data() {
    return {
      supplierLevelLists: [],
      tableData: [],
      ttQspiQbrPlanIds: [],
      monthList: [],
    }
  },
  created() {

  },
  mounted() {
    this.queryData()
  },
  methods: {
    queryData() {
      this.ttQspiQbrPlanIds = JSON.parse(this.$route.query.ttQspiQbrPlanIds)
      console.log('ttQspiQbrPlanIds', this.ttQspiQbrPlanIds);
      QBRApi.getQbrPlanLists({
        ttQspiQbrPlanIds: this.ttQspiQbrPlanIds,
        pageSize: -1
      }).then(res => {
        this.tableData = res.data.records;
      });
    },
    gradeChange(val, row) {
      console.log('val', val);
      this.$set(row, 'minFrequency', val)
    },
    onSave() {
      let flag = false;
      for (var i = 0; i < this.tableData.length; i++) {
        var ele = this.tableData[i]
        this.$set(ele, 'monthList', [])
        if (ele.isJanCheck) {
          ele.monthList.push('0' + 1)
        }
        if (ele.isFebCheck) {
          ele.monthList.push('0' + 2)
        }
        if (ele.isMarCheck) {
          ele.monthList.push('0' + 3)
        }
        if (ele.isAprCheck) {
          ele.monthList.push('0' + 4)
        }
        if (ele.isMayCheck) {
          ele.monthList.push('0' + 5)
        }
        if (ele.isJunCheck) {
          ele.monthList.push('0' + 6)
        }
        if (ele.isJulCheck) {
          ele.monthList.push('0' + 7)
        }
        if (ele.isAugCheck) {
          ele.monthList.push('0' + 8)
        }
        if (ele.isSepCheck) {
          ele.monthList.push('0' + 9)
        }
        if (ele.isOctCheck) {
          ele.monthList.push(10)
        }
        if (ele.isNovCheck) {
          ele.monthList.push(11)
        }
        if (ele.isDecCheck) {
          ele.monthList.push(12)
        }
        if (!ele.grade) {
          this.$my_message('请选择供应商等级', 'error')
          return;
        }
        // console.log('ele', ele);
        if ((ele.minFrequency == 3 && ele.monthList.length < 3) || (ele.minFrequency == 2 && ele.monthList.length < 2) || (ele.minFrequency == 1 && ele.monthList.length < 1)) {
          this.$my_message('至少勾选大于等于min频率的计划才能保存', 'error')
          return;
        }
      };
      QBRApi.saveQbrPlan(this.tableData).then(res => {
        console.log('保存', res);
        if (res.meta.code === 200) {
          this.$message.success('保存成功')
          this.$router.go(-1)
        }
      });
    },
    routerBack() {
      this.$router.back();
    },
  }
}
</script>
<style lang="scss" scoped>
</style>